import React, { useState } from "react";
import { Link } from "react-router-dom";

// Tags (menu items) with submenus
const Tags = [
  { name: "Home", link: "/" },
  {
      name: "Register",
      link: "/registeruser",
  },
  {
      name: "Jal Booking",
      link: "/createbooking",
  },
      { name: "My Bookings", link: "/mybookings" },

  {
      name: "Reports",
      link: "",
      submenu: [
        { name: "Booking Sheet", link: "/bookingreportdownloader" },
        { name: "Delivery Sheet", link: "/deliveryreportdownloader" },
      ],
    },
  // { name: "Recognition", link: "/recognition" },
  {
      name: "Login",
      submenu: [
        { name: "Admin login", link: "/adminlogin" },
        { name: "Forgot Password", link: "/forgotpassword" },
        // { name: "Reset Password", link: "/resetpassword" },
      ],
  },
  // { name: "Complain", link: "/enquiry" },
  { name: "OCRWS PH-1", link: "https://omaxecityresidents.co.in/" },
  
];

const Sidebar = ({ toggleSidebar, setToggleSidebar }) => {
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  // const handleClick = () => {
  //   // Scroll to the top of the page
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  // };
  // Toggle submenu visibility
  const handleSubMenuToggle = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
  };

  // Handle menu item click
  const handleMenuItemClick = (index) => {
    setActiveSubMenu(activeSubMenu === index ? null : index);
    setToggleSidebar(false); // Close the sidebar
  };

  return (
    toggleSidebar && (
      <div className="sidebar-container">
        <ul className="sidebar-ul">
          {Tags.map((item, index) => (
            <li key={index} style={{ marginBottom: "0.5rem" }}>
              {" "}
              {/* Reduced vertical space */}
              <Link
                to={item.link}
                className="sidebar-link"
                onClick={() => {
                  if (item.submenu) {
                    handleSubMenuToggle(index);
                  } else {
                    handleMenuItemClick(index);
                  }
                }}
              >
                {item.name}
              </Link>
              {/* Render submenu if available */}
              {item.submenu && activeSubMenu === index && (
                <ul className="sidebar-submenu-ul">
                  {item.submenu.map((subItem, subIndex) => (
                    <li key={subIndex} style={{ marginBottom: "0.25rem" }}>
                      <Link
                        to={subItem.link}
                        className="sidebar-submenu-link"
                        onClick={() => handleMenuItemClick(index)}
                      >
                        {subItem.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    )
  );
};

export default Sidebar;
